<template>
  <a-row class="p-4 h-100">
    <a-col v-if="!isLoading" span="24" class="h-100">
      <device-list
        :device-list="deviceList"
        :device-hover-info="deviceHoverInfo"
        :table-headers="tableHeadersV2"
        :table-row-columns="tableRowColumns"
        :is-loading="isLoading"
        :task_list="task_list"
        :trained-tasks="trainedTasks"
        :task-id-to-task-name-map="taskIdToTaskNameMap"
        @updateDeviceList="updateDeviceList"
        @deleteDeviceFromDeviceList="deleteDeviceFromDeviceList"
      />
    </a-col>
    <a-col
      v-else
      span="24"
      style="background-color: white"
      class="h-100 d-flex justify-content-center align-items-center"
    >
      <div style="height: 500px" class="w-100 d-flex">
        <a-spin size="medium" class="m-auto" />
      </div>
    </a-col>
  </a-row>
</template>
<script>
import trainingStatuses from '@/config/training-status-config.js';
import { InfoCircleOutlined } from '@ant-design/icons-vue';
import { notification } from 'ant-design-vue';
import { h } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import DeviceList from './DeviceListV2.vue';

export default {
  components: { DeviceList },
  inject: ['toast'],
  data() {
    return {
      isDevicesLoading: false,
      tableHeadersV2: [
        {
          title: 'Device Name',
          dataIndex: 'device_name',
          key: 'device_name',
          width: '10%',
        },
        {
          title: 'Current Task',
          dataIndex: 'current_task',
          key: 'current_task',
          width: '30%',
          align: 'center',
        },
        {
          title: 'Activity',
          dataIndex: 'activity',
          key: 'activity',
          width: '30%',
          align: 'center',
        },
        {
          title: 'Mode',
          dataIndex: 'traceOff',
          key: 'traceOff',
          width: '20%',
          align: 'center',
        },
        {
          title: 'Actions',
          dataIndex: 'actions',
          key: 'actions',
          width: '10%',
          align: 'center',
        },
        // {title: 'CAMERA CONTROLS', dataIndex: 'camera_controls', key:'camera_controls', width:'90px'},
        // // 'SCHEDULE TASK',
        // {title: 'GUIDANCE CONTROLS', dataIndex: 'guidance_controls', key:'guidance_controls', width:'90px'},
        // {title: '', dataIndex: 'lastcol', key:'lastcol', width:'90px'}
      ],
      tableHeaders: [
        '',
        'DEVICE DETAILS',
        'MANAGE ONLINE',
        'RECORD CONTROLS',
        'DEVICE CONTROLS',
        'CAMERA CONTROLS',
        'CURRENT OPERATION',
        // 'SCHEDULE TASK',
        {
          title: 'GUIDANCE CONTROLS',
          dataIndex: 'guidance_controls',
          key: 'guidance_controls',
          width: '90px',
        },
        { title: '', dataIndex: 'lastcol', key: 'lastcol', width: '90px' },
      ],
      deviceHoverInfo: [
        { key: 'Serial_number', title: 'Serial Number' },
        { key: 'last_Active', title: 'Last Active' },
        { key: 'version_no', title: 'Version' },
        { key: 'os_info', title: 'OS Info' },
        { key: 'gpu', title: 'GPU' },
        { key: 'ram', title: 'RAM' },
        { key: 'Organization', title: 'Organization' },
        { key: 'email', title: 'Email Address' },
      ],
      tableRowColumns: [
        'Serial_number',
        'device_active_status',
        'Current_task_running',
        'Manage',
        [
          'Blur Face',
          'Record Trace',
          'Use Start/End Time',
          'Record Training Set',
          'Multiple Cameras',
          'Remote Cameras',
          'Enable Translation',
          'Depth Camera',
          'Projector',
          'Box Visualization',
          'Previous Cycle Error',
          'Show/Hide Cameras',
          'Enable Auto Updates',
          'Show/Hide Step Media',
          'Show/Hide Task Steps',
          'Cap FPS',
        ],
        'inferenceControls',
        'updateDevice',
        'display_name',
      ],
      deviceList: [],
      organization: localStorage.getItem('organization'),
      isLoading: true,
      task_list: [],
      taskIdToTaskNameMap: {},
      // trainedTasks: []
    };
  },

  computed: {
    ...mapGetters(['devices', 'allTasks', 'trainedTasks', 'activeDevices']),
  },

  watch: {
    devices: {
      handler(val, previousDevices) {
        if (val.length == previousDevices.length) return;
        this.deviceList = val.map((d) => ({
          ...d,
          active: false,
          serviceStatus: false,
          title: d.display_name || d.Serial_number,
          task: d.Task && this.taskIdToTaskNameMap[d.Task],
        }));
      },
      deep: true,
    },
  },

  created() {
    this.fetchOrgDevices();
    if (
      this.devices.length == 0 ||
      this.allTasks.length == 0 ||
      this.trainedTasks.length == 0
    ) {
      this.showNotification();
    }
  },

  beforeUnmount() {
    notification.destroy();
  },

  methods: {
    ...mapActions([
      'getOrgDevices',
      'getAllTasks',
      'getTrainedTasks',
      'setActiveDevices',
    ]),
    /**
     * Fetches the organization's devices and initializes the `deviceList` with the first 10 devices.
     * If the `devices` array is empty, it fetches the organization's devices using the `getOrgDevices` action.
     * Otherwise, it maps the `devices` array to include additional properties like `active`, `serviceStatus`, `title`, and `task`,
     * and initializes the `deviceList` with the first 10 devices. It then starts the periodic timer to load more devices.
     * Finally, it fetches the task list and the trained task list, and sets the `isLoading` flag to false.
     */
    async fetchOrgDevices() {
      this.isDevicesLoading = true;
      if (this.devices.length == 0) {
        await this.getOrgDevices(this.organization);
        this.isDevicesLoading = false;
      } else {
        // let [err, data] = await this.setActiveDevices()
        this.deviceList = this.devices
          .map((d) => ({
            ...d,
            active: false,
            serviceStatus: false,
            title: d.display_name || d.Serial_number,
            task: d.Task && this.taskIdToTaskNameMap[d.Task],
          }))
          .slice(0, 20);
        if (this.deviceList.length == this.devices.length) {
          this.isDevicesLoading = false;
        }
        this.startLoadingMoreDevices();
      }
      await this.getTaskList();
      await this.getTrainedTaskList();

      this.isLoading = false;
    },

    /**
     * Starts a periodic timer that calls `loadMoreDevices` every 2 seconds.
     * This function is used to continuously fetch and append more devices to the `deviceList` in the component.
     */
    startLoadingMoreDevices() {
      this.intervalId = setInterval(() => {
        this.loadMoreDevices();
      }, 2000);
    },

    /**
     * Loads more devices to the `deviceList` in batches of 30.
     *
     * This method is called periodically (every 2 seconds) to fetch and append more devices to the `deviceList`.
     * It checks if the current `deviceList` length is less than the total number of `devices`, and if so, it fetches the next batch of devices.
     * The fetched devices are then mapped to include additional properties like `active`, `serviceStatus`, `title`, and `task`.
     * The `isLoadingMore` flag is set to true during the fetch and back to false afterwards.
     */
    async loadMoreDevices() {
      if (this.deviceList.length >= this.devices.length) {
        this.isDevicesLoading = false;
      }

      this.isLoadingMore = true;

      // Simulate async data fetch
      await new Promise((resolve) => setTimeout(resolve, 1000));

      const nextBatch = this.devices.slice(
        this.deviceList.length,
        this.deviceList.length + 30
      );
      const newDevices = nextBatch
        .filter(
          (d) =>
            !this.deviceList.some(
              (existing) => existing.Serial_number === d.Serial_number
            )
        )
        .map((d) => ({
          ...d,
          active: false,
          serviceStatus: false,
          title: d.display_name || d.Serial_number,
          task: d.Task && this.taskIdToTaskNameMap[d.Task],
        }));

      this.deviceList = this.deviceList.concat(newDevices);

      if (this.deviceList.length == this.devices.length) {
        this.isDevicesLoading = false;
      }

      this.isLoadingMore = false;
    },

    showNotification() {
      setTimeout(
        this.$toast.info,
        2000,
        'We are looking for active devices in your organization. This will take a few seconds.',
        {
          icon: () => h(InfoCircleOutlined),
        },
        'Looking for Device(s)'
      );
    },

    updateDeviceList(deviceDetails) {
      const { Serial_number, display_name } = deviceDetails;
      const temp = [...this.deviceList];

      let index = temp.findIndex((v) => v.Serial_number === Serial_number);

      if (index === -1) {
        const matchedDevice = this.devices.find(
          (v) => v.Serial_number === Serial_number
        );

        if (!matchedDevice) return;

        temp.push({
          ...matchedDevice,
          serviceStatus: false,
        });
        index = temp.length - 1;
      }

      const title = display_name || temp[index].display_name || Serial_number;
      temp[index] = {
        ...temp[index],
        ...deviceDetails,
        title,
      };

      this.deviceList = temp;
    },

    deleteDeviceFromDeviceList(serialNumber) {
      const filteredDevices = this.deviceList.filter(
        (device) => device.Serial_number !== serialNumber
      );

      if (filteredDevices.length < this.deviceList.length) {
        this.deviceList = filteredDevices;
      } else {
        console.log(`Device with serial number ${serialNumber} not found.`);
      }
    },

    getTaskList() {
      return new Promise(async (resolve, _) => {
        if (!this.allTasks.length) {
          await this.getAllTasks();
        }
        this.task_list = this.allTasks;
        this.taskIdToTaskNameMap = this.allTasks.reduce((res, task) => {
          res[task.id] = task.taskName;
          return res;
        }, {});
        resolve();
      });
    },

    async getTrainedTaskList() {
      if (this.trainedTasks.length) {
        return;
      }
      return await this.getTrainedTasks(trainingStatuses.trained);
    },
  },
};
</script>
